import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: 'What are the pricing options?',
  a: 'We offer three straightforward plans: Starter (£97/mo with Free Website, On-Page SEO, and SSL & Fast Loading), Unlimited (£297/mo adds CRM + Lead Tracking, SMS/Email/Review Automations, Google 5 Star Reviews Automation, and 24/7 Live AI ChatBot), and Pro (£497/mo adds 24/7 Live AI Receptionist and Automatic Appointments Booking Automation). All plans have no setup cost.'
}, {
  q: 'Are there any long-term contracts?',
  a: 'No. All our services are month-to-month. Cancel anytime with no penalties or fees. We believe in earning your business every single month by saving you time and making you money.'
}, {
  q: 'Will this actually work for MY business?',
  a: "Yes. We've helped restaurants, law firms, medical practices, real estate agents, contractors, and more. If you have customers calling, visiting your website, or need professional online presence, our automation solutions work."
}, {
  q: 'Do I need to be tech-savvy?',
  a: 'Not at all. We handle everything: setup, integration, training, and ongoing maintenance. You just tell us what you want, and we make it happen. Zero technical knowledge required.'
}, {
  q: 'What does the monthly maintenance include?',
  a: 'Monthly maintenance covers hosting, updates, monitoring, support, and ongoing optimization of your automations. Your systems stay running smoothly 24/7 with our team handling all technical aspects.'
}, {
  q: 'Can I start with one plan and upgrade later?',
  a: 'Absolutely! Start with whichever plan fits your needs best right now. You can upgrade to Unlimited or Pro at any time as your business grows and you need more automation power.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-16 md:py-24 bg-white relative z-10" data-id="element-44">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-45">
        <div className="text-center mb-10 md:mb-16" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-black text-black mb-3 md:mb-4" data-id="element-47">
            QUESTIONS?
          </h2>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-48">
            Everything you need to know
          </p>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-49">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: index * 0.1,
          ease: 'easeOut'
        }} viewport={{
          once: true
        }} className="bg-gray-50 rounded-lg md:rounded-xl overflow-hidden border border-gray-200" data-id="element-50">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-6 text-left hover:bg-gray-100 transition-colors duration-300" data-id="element-51">
                <span className="font-bold text-black text-sm md:text-lg pr-4" data-id="element-52">
                  {faq.q}
                </span>
                {openIndex === index ? <Minus className="text-primary flex-shrink-0 w-5 h-5" data-id="element-53" /> : <Plus className="text-primary flex-shrink-0 w-5 h-5" data-id="element-54" />}
              </button>
              <AnimatePresence data-id="element-55">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: 'easeOut'
            }} className="overflow-hidden" data-id="element-56">
                    <div className="p-4 md:p-6 pt-0 text-gray-600 leading-relaxed border-t border-gray-200 text-sm md:text-base" data-id="element-57">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}